export default __webpack_public_path__ + "static/media/CPF.b7ac73dc.svg";